import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { ServiceBase } from '../../../../shared/service-base/ServiceBase';
import { environment } from '../../../../../environments/environment';

@Injectable()
export class RelatorioCoafFiltroService extends ServiceBase {
  private baseUrlService: string;
  url: string;

  constructor(http: HttpClient, router: Router) {
    super(http, router);

    this.baseUrlService = environment.URL_API
  }

  protected getURL(): string {
    return this.url;
  }

  private defineURLFiltroMarca() {
    this.url = `${this.baseUrlService}/dash_filtro_marcas`;
  }

  public getFiltroMarcas(): Promise<any> {
    this.defineURLFiltroMarca();
    return this.get([]);
  }

  private defineURLFiltroDealers() {
    this.url = `${this.baseUrlService}/filtro/dealer`;
  }

  getFiltroDealers(): any {
    this.defineURLFiltroDealers();
    return this.get([]);
  }

  private defineURLFiltroGrupoEconomico() {
    this.url = `${this.baseUrlService}/filtro/grupo_economico`;
  }

  getFiltroGrupoEconomico(): any {
    this.defineURLFiltroGrupoEconomico();
    return this.get([]);
  }
}
